import { useIsMobile, useIsTablet } from 'components/App/SizeProvider';

export function useColNumber() {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  if (isTablet) {
    return 3;
  }

  if (isMobile) {
    return 1;
  }

  return 0;
}
